module.exports = __webpack_public_path__ + "static/media/broadcast-tower.5ae5e545.svg";